import { Injectable } from '@angular/core';
import { QuestionAttemptEntityService } from '@examdojo/question';
import { concatMap, EMPTY, forkJoin, merge } from 'rxjs';
import { StreakService } from '@examdojo/streak';
import { UserMarksService } from '../user/mark/user-marks.service';

@Injectable()
export class UpdateUserMarksOnAttemptGradedService {
  constructor(
    private readonly questionAttemptService: QuestionAttemptEntityService,
    private readonly userMarksService: UserMarksService,
    private readonly streakService: StreakService,
  ) {
    this.questionAttemptService.attemptGraded$
      .pipe(concatMap(({ awardedMarks }) => this.syncMarksAndStreaks(awardedMarks)))
      .subscribe();
  }

  private syncMarksAndStreaks(awardedMarks: number) {
    return merge(
      this.userMarksService.getUserSpentPointsAndLimits(),
      awardedMarks > 0
        ? forkJoin([this.userMarksService.fetchLastWeekUserMarks(), this.streakService.fetchStreaks()])
        : EMPTY,
    );
  }
}
